<template>
  <b-sidebar
    id="notifications-drawer"
    title="Notificações"
    :visible.sync="isDrawerVisible"
    shadow
    right
    :width="'30%'"
    backdrop
    header-class="text-center"
    @hidden="$emit('notification-drawer-closed')"
  >
    <div
      class="notifications-container"
      style="height: 90vh; overflow-y: auto; padding: 1rem;"
    >
      <template v-if="hasNotifications">
        <NotificationItem
          v-for="notification in sortedNotifications"
          :key="notification.id"
          :notification="notification"
          @open-notification-modal="$emit('open-notification-modal', $event)"
        />
      </template>
      <template v-else>
        <div style="display : flex; justify-content: center; align-items: center; height: 100%;">
          <p
            style="font-size: 1.2rem; color: gray;"
          >
            Não há notificações no momento.
          </p>
        </div>
      </template>
    </div>
  </b-sidebar>
</template>

<script>
import NotificationItem from './NotificationItem.vue'
// import api from '@/app-modulo/comuns/notificacao/shared/services/api'

export default {
  name: 'NotificationsDrawer',
  components: {
    NotificationItem,
  },
  props: {
    isDrawerVisible: {
      type: Boolean,
      required: true,
    },
    hasNotifications: {
      type: Boolean,
      required: true,
    },
    notificationCount: {
      type: Number,
      required: false,
      default: 0,
    },
    notifications: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedNotifications() {
      return [...this.notifications] // Cria uma cópia para evitar efeitos colaterais
        .sort((a, b) => {
          if (a.visualizada === b.visualizada) {
            return new Date(b.dataCadastro) - new Date(a.dataCadastro)
          }
          return a.visualizada ? 1 : -1
        })
        .slice(0, 7) // Limita a 7 notificações
    },
  },
  methods: {
    closeDrawer() {
      this.$emit('notification-drawer-closed')
    },
  },
}
</script>

<style scoped>
.notifications-container {
  height: 90vh;
  overflow-y: auto;
  padding: 1rem;
}
</style>
